import { render, staticRenderFns } from "./UploaderComponent.vue?vue&type=template&id=64ff4a78&"
import script from "./UploaderComponent.vue?vue&type=script&lang=js&"
export * from "./UploaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports